import React from 'react';
import PropTypes from 'prop-types';
import Button from 'kepler/lib/components/Button';
import Form from 'kepler/lib/components/Form';
import FormField from 'kepler/lib/components/FormField';

const MyAppCardItemButton = props => {
  const { id, btnText, btnType = 'secondary', btnSize = 'sm', onClick } = props;

  return (
    <Form className="myapp--btn" type="inline">
      <FormField>
        <Button id={id} type={btnType} size={btnSize} onClick={onClick}>
          {btnText}
        </Button>
      </FormField>
    </Form>
  );
};

MyAppCardItemButton.propTypes = {
  id: PropTypes.string,
  btnType: PropTypes.string,
  btnSize: PropTypes.string,
  btnText: PropTypes.string,
  onClick: PropTypes.func
};

export default MyAppCardItemButton;
